import { put, call, takeLatest } from 'typed-redux-saga'
import { userDocumentsApi, userDocumentsSlice, UserDocumentsNS } from 'Pages/profile'
import { loadersSlice } from 'Modules'

export function* getAllSaga(action: UserDocumentsNS.GetAll) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		const documents = yield* call(userDocumentsApi.getAll)
		yield* put(userDocumentsSlice.actions.setAll(documents))
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* createOneSaga(action: UserDocumentsNS.CreateOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(userDocumentsApi.createOne, action.payload)
		yield* put(userDocumentsSlice.actions.getAll())
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* deleteOneSaga(action: UserDocumentsNS.DeleteOne) {
	try {
		yield* put(loadersSlice.actions.showGlobalLoader())
		yield* call(userDocumentsApi.deleteOne, action.payload)
		yield* put(userDocumentsSlice.actions.getAll())
		yield* put(loadersSlice.actions.hideGlobalLoader())
	} catch (error) {
		yield* put(loadersSlice.actions.hideGlobalLoader())
	}
}

export function* userDocumentsSaga() {
	yield* takeLatest(userDocumentsSlice.actions.getAll, getAllSaga)
	yield* takeLatest(userDocumentsSlice.actions.createOne, createOneSaga)
	yield* takeLatest(userDocumentsSlice.actions.deleteOne, deleteOneSaga)
}
